export const enforcementMenu = [
  {
    path: "/enforcement-parent",
    name: "enforcement-parent",
    redirect: "/enforcement",
    icon: "shield",
    meta: {
      title: "Enforcement",
      parentMenu: true,
      ability: { action: "read", subject: ["Enforcement"] },
    },
    children: [
      {
        path: "/enforcement/investigation",
        name: "enforcement.investigation.index",
        icon: "search",
        component: () =>
          import("@/views/Enforcement/Main/InvestigationPage.vue"),
        meta: {
          title: "Investigation",
          ability: { action: "create", subject: "Enforcement" },
        },
      },
      {
        path: "/enforcement/sellers",
        name: "enforcement.sellers.index",
        icon: "user-check",
        component: () =>
          import("@/views/Enforcement/Main/Sellers/UnauthorizedSellers.vue"),
        meta: {
          title: "Unauthorized Sellers",
          ability: { action: "read", subject: "Enforcement" },
        },
      },
      {
        path: "/enforcement/logs",
        name: "enforcement.logs.index",
        icon: "book-open",
        component: () =>
          import("@/views/Enforcement/Main/CommunicationLogs.vue"),
        meta: {
          title: "Communication Logs",
          ability: { action: "read", subject: "Enforcement" },
        },
      },
      {
        path: "/enforcement/4",
        name: "enforcement-4-s",
        icon: "settings",
        meta: {
          title: "Settings",
          parentMenu: true,
          ability: { action: "read", subject: "Enforcement" },
        },
        children: [
          {
            path: "/enforcement/settings/connections",
            name: "enforcement-settings-connections",
            icon: "link",
            meta: {
              title: "Connections",
              parentMenu: true,
              ability: { action: "read", subject: "Enforcement" },
            },
            children: [
              {
                path: "/enforcement/smtp",
                name: "enforcement.smtp.index",
                icon: "mail",
                component: () =>
                  import(
                    "@/views/Enforcement/Settings/Connections/SMTPPage.vue",
                  ),
                meta: {
                  title: "SMTP",
                  ability: { action: "read", subject: "Enforcement" },
                },
              },
              {
                path: "/enforcement/oauth",
                name: "enforcement.oauth.index",
                icon: "server",
                component: () =>
                  import(
                    "@/views/Enforcement/Settings/Connections/OauthPage.vue",
                  ),
                meta: {
                  title: "OAuth2",
                  pageTitle: "OAuth2 Configuration",
                  ability: { action: "read", subject: "Enforcement" },
                },
              },
            ],
          },
          {
            path: "/enforcement/templates",
            name: "enforcement.templates.index",
            icon: "file-text",
            component: () =>
              import(
                "@/views/Enforcement/Settings/Templates/ViolationTemplates.vue",
              ),
            meta: {
              title: "Violation Templates",
              ability: { action: "read", subject: "Enforcement" },
            },
          },
          {
            path: "/enforcement/bcc",
            name: "enforcement.bcc.index",
            icon: "at-sign",
            component: () =>
              import("@/views/Enforcement/Settings/BCC/BCCList.vue"),
            meta: {
              title: "BCC",
              ability: { action: "read", subject: "Enforcement" },
            },
          },
          {
            path: "/enforcement/prioritization",
            name: "enforcement.prioritization.index",
            icon: "trending-up",
            meta: {
              title: "Prioritization",
              parentMenu: true,
              ability: { action: "update", subject: "Enforcement" },
            },
            children: [
              {
                path: "/enforcement/prioritization/index",
                name: "enforcement-prioritization-queue",
                icon: "list",
                component: () =>
                  import(
                    "@/views/Enforcement/Settings/Prioritization/QueuePage.vue",
                  ),
                meta: {
                  title: "Queue",
                  pageTitle: "Prioritization Queue",
                  ability: { action: "update", subject: "Enforcement" },
                },
              },
              {
                path: "/enforcement/prioritization/settings",
                name: "enforcement.configuration.index",
                icon: "settings",
                component: () =>
                  import(
                    "@/views/Enforcement/Settings/Prioritization/SettingsPage.vue",
                  ),
                meta: {
                  title: "Settings",
                  pageTitle: "Prioritization Settings",
                  ability: { action: "update", subject: "Enforcement" },
                },
              },
            ],
          },
        ],
      },
    ],
  },
];

export const enforcementRoutes = [
  {
    path: "/enforcement/templates/create",
    name: "enforcement.templates.create",
    component: () =>
      import("@/views/Enforcement/Settings/Templates/CreateTemplate.vue"),
    meta: {
      title: "Create Template",
      ability: { action: "create", subject: "Enforcement" },
    },
  },
  {
    path: "/enforcement/templates/:id/edit",
    name: "enforcement.templates.edit",
    component: () =>
      import("@/views/Enforcement/Settings/Templates/EditTemplate.vue"),
    meta: {
      title: "Edit Template",
      ability: { action: "update", subject: "Enforcement" },
    },
  },
  {
    path: "/enforcement/sellers/:id/profile",
    name: "enforcement.seller.profile.index",
    component: () =>
      import("@/views/Enforcement/Main/Sellers/SellerProfile.vue"),
    meta: {
      title: "Seller Profile",
      ability: { action: "read", subject: "Enforcement" },
    },
  },
  {
    path: "/enforcement/sellers/:id/send",
    name: "enforcement.sellers.send",
    component: () =>
      import("@/views/Enforcement/Main/Sellers/SellerSendEmail.vue"),
    meta: {
      title: "Seller Send Email",
      ability: { action: "create", subject: "Enforcement" },
    },
  },
];
